export default __webpack_public_path__ + "static/media/braces-autoligados.d56598fb.png";